// extracted by mini-css-extract-plugin
export var auto = "_41-1";
export var spinner = "_41-0";